import styled, { css } from 'styled-components';


export const Title = styled.h2`
  ${({ theme }) => css`
    align-self: flex-start;
    color: ${theme.v2.colors.brand.primaryExtraDark};
    display: flex;
    font-size: ${theme.v2.font.sizes.lg};
    font-weight: ${theme.v2.font.weights.bold};
    gap: 8px;
    margin: 0;
    text-align: left;
  `}
`;

export const Description = styled.p`
  ${({ theme }) => css`
    align-self: flex-start;
    color: ${theme.v2.colors.neutral.lowDark};
    font-size: ${theme.v2.font.sizes.sm2};
    margin: 16px 0px 0px;
    max-width: 690px;
    text-align: left;
  `}
`;

export const Subtitle = styled.h3`
  ${({ theme }) => css`
    align-self: flex-start;
    color: ${theme.v2.colors.brand.primaryMedium};
    font-size: ${theme.v2.font.sizes.sm2};
    font-weight: ${theme.v2.font.weights.bold};
    margin: 24px 0 0px;
    text-align: left;
  `}
`;


export const List = styled.ul`
  align-self: flex-start;
  display: flex;
  flex-direction: column;
  gap: 16px;
  list-style: none;
  margin: 8px 0px 0px 0px;
  padding: 0px;
`;

export const ListItem = styled.li`
  ${({ theme }) => css`
    align-items: flex-start;
    color: ${theme.v2.colors.neutral.lowDark};
    display: flex;
    flex-direction: row;
    font-family: ${theme.v2.font.family.primary};
    font-size: ${theme.v2.font.sizes.xs};
    font-weight: ${theme.v2.font.weights.regular};
    gap:10px;
    line-height: ${theme.v2.font.lineHeight.list};
    text-align: left;

    svg {
      position: relative;
      top: 5px;
    }
  `}
`;
